<div *ngIf="loader" id="spinerLoader" class="container">
    <div class="loader">Loading...</div>
</div>

<div mat-dialog-title class="modal-header header-radius-4 py-0">
    <div class="mx-3 d-flex justify-content-between align-items-center">
        <div>
            <h4>{{ data.header }}</h4>
        </div>
        <div>
            <button mat-dialog-close class="close close-btn" type="button">
                <i class="fa fa-close"></i>
            </button>
        </div>
    </div>
</div>
<mat-dialog-content>
    <div class="p-0 mx-4 mb-4">
        <form id="addCustomer" #loginForm="ngForm" name="loginForm">
            <div class="modal-body">
                <div class="member-card">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>Name<span class="text-danger">*</span></label>
                                <input
                                    id="customerName"
                                    class="form-control"
                                    #CustomerName="ngModel"
                                    maxlength="100"
                                    name="CustomerName"
                                    required
                                    type="text"
                                    [ngClass]="{ 'is-invalid': loginForm.submitted && CustomerName.invalid }"
                                    [placeholder]="data.header != 'Add Partner' ? 'Customer Name' : 'Partner Name'"
                                    [(ngModel)]="customer.name"
                                />
                                <div *ngIf="loginForm.submitted && CustomerName.invalid" class="invalid-feedback">
                                    <div *ngIf="CustomerName.errors.required">
                                        <span style="color: red">Customer Name is required.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="data.header == 'Edit Partner' || data.header == 'Add Partner'" class="col-lg-6">
                            <div class="form-group">
                                <label>Type<span class="text-danger">*</span></label>
                                <select
                                    class="form-control"
                                    #type="ngModel"
                                    name="type"
                                    required
                                    [ngClass]="{ 'is-invalid': loginForm.submitted && type.invalid }"
                                    [(ngModel)]="customer.partnerType"
                                >
                                    <option disabled selected value="">select</option>
                                    <option *ngFor="let type of types" [value]="type.partnerTypeName">{{ type.partnerTypeName }}</option>
                                </select>
                                <div *ngIf="loginForm.submitted && type.invalid" class="invalid-feedback">
                                    <div *ngIf="type.errors.required"><span style="color: red">Type is required.</span></div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="data.header == 'Edit Customer' || data.header == 'Add Customer'" class="col-lg-6">
                            <div class="form-group">
                                <label>Type<span class="text-danger">*</span></label>
                                <select
                                    class="form-control"
                                    #type="ngModel"
                                    name="type"
                                    required
                                    [ngClass]="{ 'is-invalid': loginForm.submitted && type.invalid }"
                                    [(ngModel)]="customer.customerType"
                                >
                                    <option disabled selected [value]="">Select Type</option>
                                    <option *ngFor="let type of cmrType" [value]="type.customerTypeName">
                                        {{ type.customerTypeName }}
                                    </option>
                                </select>
                                <div *ngIf="loginForm.submitted && type.invalid" class="invalid-feedback">
                                    <div *ngIf="type.errors.required"><span style="color: red">Type is required.</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>Phone<span class="text-danger">*</span></label>
                                <input
                                    id="primaryContact"
                                    class="form-control"
                                    #primaryContact="ngModel"
                                    maxlength="14"
                                    minlength="14"
                                    name="primaryContact"
                                    pattern="\(?\d+\)?[-.\s]?\d+[-.\s]?\d+"
                                    placeholder="(xxx) xxx-xxxx"
                                    required
                                    type="text"
                                    [ngClass]="{ 'is-invalid': loginForm.submitted && primaryContact.invalid }"
                                    [ngModel]="customer.contact.phone | phoneNumberPipe"
                                    (ngModelChange)="customer.contact.phone = $event"
                                />
                                <div *ngIf="loginForm.submitted && primaryContact.invalid" class="invalid-feedback">
                                    <div *ngIf="primaryContact.errors.required">
                                        <span style="color: red">Phone Number is required.</span>
                                    </div>
                                    <div *ngIf="primaryContact.errors.minlength">
                                        <span style="color: red">Phone must have 10 digits.</span>
                                    </div>
                                    <div *ngIf="primaryContact.errors.pattern"><span style="color: red">Phone Number not valid.</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>Email</label>
                                <input
                                    id="email"
                                    class="form-control"
                                    maxlength="50"
                                    name="email"
                                    placeholder="Email"
                                    type="text"
                                    [(ngModel)]="customer.contact.emailId"
                                />
                            </div>
                        </div>
                    </div>

                    <div *ngIf="data.header == 'Add Customer' || data.header == 'Edit Customer'" class="row">
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>PO #</label>
                                <div
                                    class="pull-right fa-lg text-danger cursorPointer"
                                    data-target="#PO"
                                    data-toggle="modal"
                                    title="Add PO#"
                                    (click)="openPOModel()"
                                >
                                    <i class="fa fa-plus-circle mr-2"></i>
                                </div>
                                <input id="poBox" class="form-control" name="poBox" readonly type="text" [ngModel]="poBoxValue" />
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>Region</label>
                                <select
                                    class="form-control"
                                    #region="ngModel"
                                    name="region"
                                    [ngClass]="{ 'is-invalid': loginForm.submitted && region.invalid }"
                                    [(ngModel)]="customer.region"
                                >
                                    <option selected value="">None</option>
                                    <option *ngFor="let region of regionOptions" [disabled]="region.isDisabled" [value]="region.name">
                                        {{ region.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 form-group">
                            <label>Contracted Customer</label>
                            <div class="radio my-0 contracted">
                                <label>
                                    <input name="isContracted" required type="radio" [value]="true" [(ngModel)]="customer.isContracted" />
                                    <span>Yes</span>
                                </label>
                                <label>
                                    <input name="isContracted" required type="radio" [value]="false" [(ngModel)]="customer.isContracted" />
                                    <span>No</span>
                                </label>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>Contracted Response Time for Ground</label>
                                <select
                                    class="form-control"
                                    #groundResponseTime="ngModel"
                                    name="groundResponseTime"
                                    [ngClass]="{ 'is-invalid': loginForm.submitted && groundResponseTime.invalid }"
                                    [(ngModel)]="customer.groundResponseTime"
                                >
                                    <option
                                        *ngFor="let groundResponse of groundResponseTimeOptions"
                                        [disabled]="groundResponse.isDisabled"
                                        [value]="groundResponse.value"
                                    >
                                        {{ groundResponse.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngIf="data.header == 'Add Customer' || data.header == 'Edit Customer'" class="col-lg-12">
                            <div class="form-group">
                                <label>Associated Business Emails</label>
                                <i
                                    class="fa fa-question-circle fa-lg text-danger ml-2"
                                    aria-hidden="true"
                                    data-toggle="tooltip"
                                    title="Enter comma separated business emails without any space."
                                >
                                </i>
                                <ng-container>
                                    <textarea
                                        id="instruction-containerId"
                                        class="associatedBusinessEmail"
                                        class="form-control"
                                        #AssociatedEmails="ngModel"
                                        name="AssociatedEmails"
                                        placeholder="Enter Business Emails"
                                        row="4"
                                        wrap="hard"
                                        [ngClass]="{ 'is-invalid': loginForm.submitted && AssociatedEmails.invalid }"
                                        [(ngModel)]="customer.contact.businessEmail"
                                        (change)="checkEmail($event)"
                                    ></textarea>
                                </ng-container>
                                <div
                                    *ngIf="
                                        (loginForm.submitted && AssociatedEmails.invalid) ||
                                        (loginForm.submitted && invalidEmail == true) ||
                                        invalidEmail == true
                                    "
                                >
                                    <span style="color: red">Invalid Associated Emails.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="member-card">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Address Type</label><span class="text-danger"> * </span>
                                <select
                                    class="form-control"
                                    #addressType="ngModel"
                                    name="addressType"
                                    required
                                    [ngClass]="{ 'is-invalid': loginForm.submitted && addressType.invalid }"
                                    [(ngModel)]="customer.address.addressLocationType"
                                >
                                    <option disabled selected [value]="null">Select Address Type</option>
                                    <option *ngFor="let item of AddressType" name="addr_type" [value]="item">
                                        {{ item }}
                                    </option>
                                </select>
                                <div *ngIf="loginForm.submitted && addressType.invalid" class="invalid-feedback">
                                    <div *ngIf="addressType.errors.required"><span style="color: red">Address Type is required.</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Address</label><span class="text-danger"> * </span>
                                <div class="radio my-0">
                                    <label
                                        ><input
                                            #pvtOrPublic="ngModel"
                                            name="pvtOrPublic"
                                            required
                                            type="radio"
                                            [value]="false"
                                            [(ngModel)]="customer.address.isGlobal"
                                        />Private</label
                                    >
                                    <label class="ml-4"
                                        ><input
                                            #pvtOrPublic="ngModel"
                                            name="pvtOrPublic"
                                            required
                                            type="radio"
                                            [value]="true"
                                            [(ngModel)]="customer.address.isGlobal"
                                        />Public</label
                                    >
                                    <div *ngIf="loginForm.submitted && pvtOrPublic.invalid" class="invalid-feedback">
                                        <div *ngIf="pvtOrPublic.errors.required"><span style="color: red">Field is required.</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Street Address</label>
                                <input
                                    id="CMStreetAddress"
                                    class="form-control"
                                    maxlength="150"
                                    name="streetAddress"
                                    placeholder="Street Address"
                                    type="text"
                                    [(ngModel)]="customer.address.streetAddress"
                                />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Zipcode</label>
                                <input
                                    id="CMzipCode"
                                    class="form-control"
                                    #zipCode="ngModel"
                                    maxlength="5"
                                    minlength="3"
                                    name="zipCode"
                                    pattern="[A-Za-z0-9]+"
                                    placeholder="zipCode"
                                    type="text"
                                    [(ngModel)]="customer?.address.zipcode"
                                />
                                <div *ngIf="loginForm.submitted && zipCode.invalid" class="invalid-feedback">
                                    <div *ngIf="zipCode.errors.pattern">
                                        <span style="color: red">ZipCode not valid.</span>
                                    </div>
                                    <div *ngIf="zipCode.errors.minlength">
                                        <span style="color: red">ZipCode must have 3 or 5 digits.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <div>
                                    <label>State<span class="text-danger">*</span></label>
                                    <select
                                        class="form-control"
                                        #state="ngModel"
                                        name="state"
                                        required
                                        [ngClass]="{ 'is-invalid': loginForm.submitted && state.invalid }"
                                        [(ngModel)]="customer.address.stateId"
                                        (change)="getCityByState(customer.address.stateId)"
                                    >
                                        <option selected value="">select</option>
                                        <option *ngFor="let item of stateList" [value]="item.stateId">{{ item?.stateName }}</option>
                                    </select>
                                    <div *ngIf="loginForm.submitted && state.invalid" class="invalid-feedback">
                                        <div *ngIf="state.errors.required"><span style="color: red">State is required.</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>City<span class="text-danger">*</span></label>
                                <select
                                    class="form-control"
                                    #city="ngModel"
                                    name="city"
                                    required
                                    [ngClass]="{ 'is-invalid': loginForm.submitted && city.invalid }"
                                    [(ngModel)]="customer.address.city"
                                >
                                    <option *ngFor="let addCity of cityList" [value]="addCity.cityName">{{ addCity.cityName }}</option>
                                </select>
                                <div *ngIf="loginForm.submitted && city.invalid" class="invalid-feedback">
                                    <div *ngIf="city.errors.required"><span style="color: red">City is required.</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="data.header != 'Edit Customer' && data.header != 'Add Customer'" class="member-card">
                    <h4 class="filter-options my-0">Files</h4>
                    <div class="float-right mb-3">
                        <input
                            id="partnerFileUpload"
                            class="cursorPointer mt-2"
                            #fileInput
                            accept=".jpg,.jpeg,.png,.pdf"
                            multiple
                            name="partnerFile"
                            style="display: none"
                            type="file"
                            [(ngModel)]="partnerFile"
                            (input)="partnerFileUpload(partnerFile, 'partnerFileUpload')"
                        />
                        <a *ngIf="!editAllFile1" class="py-2 px-3 mr-2 button_style cursorPointer" (click)="openFile()"> Add File </a>
                        <a
                            *ngIf="data?.chooseFile?.length != 0 && !editAllFile1"
                            class="py-2 px-3 mr-2 cursorPointer button_style_edit"
                            (click)="editAllFile()"
                            >Edit File</a
                        >
                        <button
                            *ngIf="editAllFile1"
                            class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                            type="button"
                            (click)="closeAll()"
                        >
                            <i class="fa fa-close fa-md"></i>
                        </button>
                        <button
                            *ngIf="editAllFile1"
                            class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                            type="button"
                            (click)="closeViewFileModel(false)"
                        >
                            <i class="fa fa-check fa-md"></i>
                        </button>
                    </div>
                    <div class="tableMargin">
                        <table id="tblattach" class="table border-table" data-sort="false">
                            <thead class="table-thead">
                                <tr>
                                    <td class="header_td p-2" style="border-bottom: 1px !important">
                                        <div class="header_container">
                                            <div class="header_title" style="width: 29.33%">File Name</div>
                                            <div class="header_title" style="width: 40.33%">File Type</div>
                                            <div class="header_title action">Action</div>
                                        </div>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let file of data?.chooseFile | SearchByName: searchText1; let i = index">
                                    <td>
                                        <div class="row_container">
                                            <div class="title_container" [style.width]="isMobileDevice == true ? '30.33%' : '100%'">
                                                <div class="row_title">File Name</div>
                                                <div *ngIf="!file.IsEditable" class="row_detail text-color" style="word-break: break-word">
                                                    <a class="text-danger" [href]="file.filePath">
                                                        {{ file.fileName }}.{{ file.extension }}
                                                    </a>
                                                </div>
                                                <div *ngIf="file.IsEditable" class="d-flex">
                                                    <input
                                                        id="file_name_edit{{ i }}"
                                                        class="form-control mr-2"
                                                        name="file_name_edit{{ i }}"
                                                        placeholder="File Name"
                                                        type="text"
                                                        [(ngModel)]="file.fileName"
                                                    />
                                                    <span class="mt-2"
                                                        ><b>.{{ file?.extension }}</b></span
                                                    >
                                                </div>
                                            </div>
                                            <div class="title_container" [style.width]="isMobileDevice == true ? '40.33%' : '100%'">
                                                <div class="row_title">File Type</div>
                                                <input
                                                    *ngIf="file.IsEditable"
                                                    id="file_category_edit{{ i }}"
                                                    class="form-control"
                                                    name="file_category_edit{{ i }}"
                                                    type="text"
                                                    [(ngModel)]="file.fileType"
                                                />
                                                <div *ngIf="!file.IsEditable" class="row_detail" style="word-break: break-word">
                                                    {{ file?.extension }}
                                                </div>
                                            </div>
                                            <div class="title_container">
                                                <div class="row_title">Action</div>
                                                <div class="row_detail">
                                                    <button
                                                        *ngIf="!file.IsEditable"
                                                        class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                                                        title="Edit License"
                                                        (click)="fileEdit(i, file)"
                                                    >
                                                        <i class="fa fa-pencil-square"></i>
                                                    </button>
                                                    <button
                                                        *ngIf="!file.IsEditable"
                                                        class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                                                        data-target="#message"
                                                        data-toggle="modal"
                                                        title="Remove {{ file?.fileType }} file"
                                                        (click)="removeFileForPopup(i)"
                                                    >
                                                        <i class="fa fa-minus-circle"></i>
                                                    </button>
                                                    <button
                                                        *ngIf="file.IsEditable"
                                                        class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                                                        type="button"
                                                        (click)="closeDisable(i)"
                                                    >
                                                        <i class="fa fa-close fa-md"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    *ngIf="data.header == 'Add Partner'"
                    mat-dialog-close
                    class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                    type="button"
                >
                    Cancel
                </button>
                <button
                    *ngIf="data.header == 'Add Customer'"
                    mat-dialog-close
                    class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                    type="button"
                >
                    Cancel
                </button>
                <button
                    *ngIf="data.header != 'Add Partner' && data.header != 'Add Customer'"
                    mat-dialog-close
                    class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                    type=" button"
                >
                    Cancel
                </button>
                <button
                    *ngIf="data.header != 'Add Partner' && data.header != 'Add Customer'"
                    class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                    type="submit"
                    (click)="updateCustomerDetail(loginForm); closeModel()"
                >
                    Save Changes
                </button>
                <button
                    *ngIf="data.header == 'Add Partner'"
                    class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                    type="submit"
                    (click)="addPartner(loginForm)"
                >
                    Save Changes
                </button>
                <button
                    *ngIf="data.header == 'Add Customer'"
                    class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                    type="submit"
                    (click)="addCustomer(loginForm)"
                >
                    Save Changes
                </button>
            </div>
        </form>
    </div>
</mat-dialog-content>

<div id="PO" class="modal fade" aria-hidden="true" aria-labelledby="PO" tabindex="1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header content-header">
                <button class="close close-btn" aria-label="Close" data-dismiss="modal" type="button">
                    <i class="fa fa-close"></i>
                </button>
                <h4 class="modal-title">
                    PO#
                    <i *ngIf="poMappingLoader" class="fa fa-spinner fa-spin fa-lg"></i>
                </h4>
            </div>
            <div class="modal-body member-card poModal">
                <form [formGroup]="poForm">
                    <div formArrayName="organType">
                        <div *ngFor="let organ of this.organType.controls; let i = index">
                            <div [formGroupName]="i">
                                <div class="mb-2 col-md-6">
                                    <div class="col-md-6">{{ organ.value.organType }} :</div>
                                    <div class="col-md-6">
                                        <input
                                            class="form-control"
                                            formControlName="organTypeValue"
                                            type="text"
                                            [placeholder]="'Add PO# for ' + organ.value.organType"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10" data-dismiss="modal" type="button">
                    Cancel
                </button>
                <button class="flat-butt flat-info-butt flat-info-grad-butt save-btn" data-dismiss="modal" type="submit" (click)="savePO()">
                    Save Changes
                </button>
            </div>
        </div>
    </div>
</div>
